import React, { useEffect, useState } from "react";
import goToScreen from "../lib/goToScreen";
import Loader from "../Components/Loader";
import LoadLandbot from "../Components/LoadLandbot";
import isSiteBuilder from "../lib/isSiteBuilder";

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

function getCompaniesHouseDetails(myLandbotData) {
  const { user_chosen_company, companies_house_response } = myLandbotData;
  if (!companies_house_response) return null;
  return JSON.parse(companies_house_response).filter(
    (company) => company.title === user_chosen_company
  )[0];
}

async function landbotevent(myLandbotData, history) {
  myLandbotData.companies_house_details =
    getCompaniesHouseDetails(myLandbotData);
  delete myLandbotData.companies_house_response;

  if (isSiteBuilder()) return;
  window.OrendaGetResponse(
    { event_name: "new application", data: JSON.stringify(myLandbotData) },
    () => goToScreen(history, "wait"),
    false
  );
  return;
}

////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

export default function NewApply({ history }) {
  document.title = "Onboarding";

  const [loading, setLoading] = useState(true);
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (isSiteBuilder()) {
      setTimeout(() => {
        setUrl(
          "https://chats.landbot.io/v3/H-875138-JG40GB6M9OU3XY7D/index.json"
        );
        setLoading(false);
      }, 2000);
      return;
    }

    window.OrendaGetResponse(
      { event_name: "page load - new_apply" },
      ({ chatbot_url }) => {
        setUrl(chatbot_url);
        setLoading(false);
      },
      false
    );
    return;
  }, []);

  if (loading) return <Loader />;

  return (
    <div style={{ width: "100vw", height: "100vh" }}>
      <LoadLandbot
        url={url}
        event={(LandbotData) => {
          landbotevent(LandbotData, history);
          setLoading(true);
        }}
      />
    </div>
  );
}
